// extracted by mini-css-extract-plugin
export default {"list":"ratio-list_list__hvf9c","card":"ratio-list_card__il+n6"};